import * as Styled from "./TabOverdue.styles";

import { useCallback, useEffect, useState } from "react";

import Button from "@component/Button/Button";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ErrorComponent from "@component/Error/Error";
import OrderList from "@component/Order/OrderList";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import TabPaymentMethodList from "@component/TabPaymentMethodList/TabPaymentMethodList";
import TabSummary from "@component/TabSummary/TabSummary";
import closeTabOverdue from "@utils/closeTabOverdue";
import { useAuth } from "@context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTab } from "@context/TabContext";
import getTabOverdue, { TabOverdueFields } from "../../utils/getTabOverdue";

function TabOverdue() {
  const [isLoading, setIsLoading] = useState<boolean>();
  const [error, setError] = useState<string>();


  const { webTabSession } = useAuth();
  const selectedPaymentMethod = webTabSession?.selectedPaymentMethod;

  const { placeCode, setIsOverdue } = useTab();

  const navigate = useNavigate();

    const [overdueTab, setOverdueTab] = useState<TabOverdueFields | undefined>(undefined);

    useEffect(() => {
        setIsLoading(true);
        getTabOverdue()
          .then(res => {
                setOverdueTab(res?.overdueTabs[0]);
                setIsLoading(false);
            })
          .catch(error => {
                console.error(error);
                setIsLoading(false);
            });
    }, []);

  const handleCloseTab = useCallback(async () => {
    setIsLoading(true);
    setIsOverdue(false);

    if (!selectedPaymentMethod) {
      setIsLoading(false);

      setError(
        "There's an error with your payment method. Try again with a different payment method."
      );

      throw new Error("Selected Payment Method Id is missing.");
    }

    const nextScreen = await closeTabOverdue();

    if (nextScreen) {
      navigate(`/venue/${placeCode}/complete`, {
        replace: true,
      });
    }

    setIsLoading(false);
  }, [navigate, placeCode, selectedPaymentMethod, setIsOverdue]);

  return (
    <Styled.Container direction="column" className="tab-overdue">
      <Styled.IconOuterContainer direction="column">
        <Styled.IconContainer>
          <PriorityHighIcon />
        </Styled.IconContainer>

        <h4>Unpaid Tab</h4>
        <p>
          Something went wrong while processing your payment. Before you can
          Rooam again you must settle the balance from your last tab.
        </p>
      </Styled.IconOuterContainer>

      <TabPaymentMethodList isOverdue={true} />
      <h3>Tab Details</h3>
      {overdueTab?.items && <OrderList items={overdueTab?.items} />}
      <TabSummary
        collapsible={false}
        fees={overdueTab?.baseFare ?? "0.00"}
        serviceCharges={overdueTab?.serviceCharges ?? "0.00"}
        subtotal={overdueTab?.subTotal ?? "0.00"}
        tax={overdueTab?.tax ?? "0.00"}
        tip={overdueTab?.tip ?? "0.00"}
        total={overdueTab?.total ?? "0.00"} partialPayment={"0.00"}/>

      <Styled.ButtonContainer className="btn-container">
        {error && (
          <ErrorComponent>
            <strong>Error: </strong>
            {error}
          </ErrorComponent>
        )}
        <Button
          isLoading={isLoading}
          color="secondary"
          node={
            <div>
              <CreditCardIcon />
              <span>Close Tab: ${overdueTab?.total}</span>
            </div>
          }
          onClick={() => {
            void handleCloseTab();
          }}
        />
      </Styled.ButtonContainer>
    </Styled.Container>
  );
}

export default TabOverdue;
